import firebase from 'firebase';
import 'firebase/firestore';

firebase.initializeApp({
  apiKey: 'AIzaSyAqaF-6pe6wxykLHyB7CkG4TxYXsu3a6zg',
  authDomain: 'my-spa-1ae0e.firebaseapp.com',
  databaseURL: 'https://my-spa-1ae0e.firebaseio.com',
  projectId: 'my-spa-1ae0e',
  storageBucket: 'my-spa-1ae0e.appspot.com',
  messagingSenderId: '535290719088',
  appId: '1:535290719088:web:1cf171d8d605a11cadfdb5',
});

export const auth = firebase.auth();

export const fbStorage = firebase.storage();

export const fbStore = firebase.firestore();

export default firebase;
